import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes.js";
import titleControl from "../utils/titleControl.js";
Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  mode: "history",
});

router.afterEach((to, from) => {
  //路由标题 to.meta.title
  if (to.meta) {
    titleControl.setRouteTitle(to.meta.title);
  }
});

export default router;
